import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { openOrCloseGlobalDialog } from '../action/dialog/global-dialog';
import { loadOrg } from '../organization/actions/load-org';
import { userSelector } from '../reducers/current-user-selectors';
import { orgSelector } from '../reducers/org-selectors';

import { PayrollIntegrationButton } from '../merge-integration/payroll-integration-button';
import { UiButton } from '../ui/ui-button';

import { EmployeeListUpload } from './employee-list-upload';
import { ReactComponent as EmployeesEmptyIllustration } from './employees-empty-illustration.svg';

type InputProps = {
  orgId: number;
  listUploadOnly?: boolean;
};

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  org: orgSelector(state, orgId),
  user: userSelector(state),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadOrg: () => dispatch(loadOrg(orgId)),
    toggleAddEmployeeDialog: (isOpen: boolean, onClose?: () => void) =>
      dispatch(openOrCloseGlobalDialog('addEmployeeDialog', isOpen, { orgId, onClose })),
  },
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps & ReduxProps;

export const EmployeeEmptyState = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ orgId, org, user, actions, listUploadOnly }: Props) => {
  useEffect(() => {
    actions.loadOrg();
  }, [actions, user.isAccountAdmin]);

  if (!org) {
    return null;
  }

  const onClose = () => {
    actions.toggleAddEmployeeDialog(false);
  };

  const openIsAddingEmployee = () => {
    actions.toggleAddEmployeeDialog(true, onClose);
  };

  return (
    <div className="card-body u-display-flex u-flexDirection-column u-alignItems-center u-padding-lg">
      <EmployeesEmptyIllustration className="u-width-100 u-maxWidth-200px" />
      <div className="u-margin-lg u-textAlign-center">
        Team Engine&apos;s Employee Messaging Platform lets you easily communicate with your teams
        by text and email, all within a seamless inbox so you don&apos;t have to rely on bulletin
        boards, trading phone calls or tracking someone down.
      </div>
      <div className="u-display-flex u-flexWrap-wrap u-justifyContent-center">
        <div className="u-margin-sm">
          <EmployeeListUpload size="sm" orgId={orgId} />
        </div>
        {!listUploadOnly && (
          <>
            <div className="u-margin-sm">
              <PayrollIntegrationButton className="u-height-100" org={org} size="sm" />
            </div>
            <UiButton size="sm" className="u-margin-sm" onClick={openIsAddingEmployee}>
              Add Employee
            </UiButton>
          </>
        )}
      </div>
    </div>
  );
});
